
const defaultProps = {
  id: '-1',
  lastInitial: '',
  name: '',
  role: 'user',
  avatarSrc: ''
};

/** Helper function.
 * Maps the warehouse Product instance fields to our internal fields.
 */
const convertInternal = (whConversationMember) => {
  return {
    id: whConversationMember.userId ? whConversationMember.userId.toString() : defaultProps.id,
    lastInitial: whConversationMember.lastInitial || defaultProps.lastInitial,
    name: whConversationMember.name || defaultProps.name,
    role: whConversationMember.role || defaultProps.user,
    avatarSrc: `/${whConversationMember.avatarSrc || defaultProps.avatarSrc}`
  };
};

class ConversationMember {
  /**
   * Creates a new ConversationMember based on the server response
   * @argument whConversationMember: server response member info
   */
  static createFromWarehouseResponse ({ whConversationMember }) {
    return new ConversationMember({
      ...convertInternal(whConversationMember)
    });
  }

  /** Creates a new ConversationMember
   * @argument fields: The attributes to add to this instance
   */
  constructor (fields = defaultProps) {
    Object.assign(this, fields);
  }

  /** Generates a copy of the ConversationMember instance
   * @argument overrides: The attributes to add to the new instance
  */
  makeCopy (overrides) {
    return new ConversationMember({
      id: this.id,
      lastInitial: this.lastInitial,
      name: this.name,
      role: this.role,
      imageSrc: this.image,
      ...overrides
    });
  }
}

export default ConversationMember;
